/**
 * Represents different types of third parties.
 */
export enum ThirdPartyTypeModel {
	/**
	 * Represents a Business Development Company (BDC) third party.
	 */
	Bdc = 1,
	/**
	 * Represents an internal third party, typically within the organization.
	 */
	Internal = 2,
	/**
	 * Represents a Group Purchasing Organization (GPO) third party.
	 */
	Gpo = 3
}
